import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export default function ExportOrdenesServicioPOButton({ data }) {

  const exportar = async () => {

    if (!data || data.length === 0) {
      message.warning("No hay datos para exportar");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Registro de productos");

    sheet.mergeCells("A1:N1");
    const title = sheet.getCell("A1");
    title.value = "REGISTRO DE PRODUCTOS (PO)";
    title.font = { size: 18, bold: true, color: { argb: "FFFFFFFF" } };
    title.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF042956" } };
    title.alignment = { vertical: "middle", horizontal: "center" };
    sheet.getRow(1).height = 30;

    sheet.mergeCells("A2:N2");
    const info = sheet.getCell("A2");
    info.value = `Fecha de generación: ${dayjs().format("DD/MM/YYYY HH:mm")}`;
    info.alignment = { horizontal: "center" };

    sheet.addRow([]);

    const headers = ["PO", "Proveedor", "Fecha entrega PO", "Proyecto", "Municipio", "Producto", "Descripción", "Unidad", "Cantidad", "Entregado", "Stock", "Precio unitario COP", "Valor total COP", "Observación"];
    const headerRow = sheet.addRow(headers);

    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1F4E78" } };
      cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
    });

    data.forEach((p) => {
      const fecha = p.fecha_entrega_po || p.fecha_estimada_entrega;
      const row = sheet.addRow([
        p.Numero_PO,
        p.nombre,
        fecha ? dayjs(fecha).format("DD/MM/YYYY") : "",
        p.codigo ? `${p.codigo} - ${p.proyecto}` : "",
        p.municipio || "",
        p.nombre_producto,
        p.descripcion || p.tipo_producto || "",
        p.unidad_medida || "",
        Number(p.cantidad_comprada || 0),
        Number(p.cantidad_entregada || 0),
        Number(p.stock_disponible || 0),
        Number(p.valor_unitario_COP || 0),
        Number(p.valor_total_COP || 0),
        p.observacion || ""
      ]);
      row.eachCell((cell) => {
        cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
        cell.alignment = { vertical: "middle", wrapText: true };
      });
    });

    sheet.getColumn(12).numFmt = '"$"#,##0.00';
    sheet.getColumn(13).numFmt = '"$"#,##0.00';

    sheet.columns = [
      { width: 14 }, { width: 35 }, { width: 16 }, { width: 40 }, { width: 20 }, { width: 35 }, { width: 45 },
      { width: 14 }, { width: 12 }, { width: 12 }, { width: 12 }, { width: 20 }, { width: 20 }, { width: 40 }
    ];

    sheet.views = [{ state: "frozen", ySplit: 4 }];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `registro_productos_po_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`);
  };

  return (
    <Button icon={<DownloadOutlined />} onClick={exportar} type="default">
      Exportar
    </Button>
  );
}
